export function withCache<K, V>(map: Map<K, V>, key: K, build: () => V): V {
  if (map.has(key)) return map.get(key) as V;
  const value = build();
  map.set(key, value);
  return value;
}
